import type { CasinoConfigResponse, CasinoConfigType } from './types';
import { booleanFormatter, parseFormatter, splitFormatter, tablesFormatter, tabsFormatter } from './utils';

export const casinoConfigParser = (response: CasinoConfigResponse): CasinoConfigType => {
  const params = response.params;
  return {
    cashierIframeEvent: booleanFormatter(params.cashier_iframe_event),
    cashierPopupEnabled: booleanFormatter(params.cashier_popup_enabled),
    cashierUrl: params.cashier_url,
    cashierUrlFirst: params.cashier_url_first,
    cashierUrlMobile: params.cashier_mobile,
    casinoId: response.casinoId,
    casinoName: response.casinoName,
    casinoRegion: response.casinoRegion,
    chatDisabled: booleanFormatter(params.chat_disabled),
    exitUrl: params.exit_url,
    forceHideNetPosition: params.net_position === 'false',
    heroBanners: splitFormatter(params.hero_banners),
    hideBonusBalance: booleanFormatter(params.hide_bonus),
    hideSessionTimer: booleanFormatter(params.hide_session_time),
    hideCurrency: booleanFormatter(params.hide_currency),
    hideFullScreenBtn: booleanFormatter(params.hidefullscreenbtn),
    hideLobbyButtons: booleanFormatter(params.hide_lobby_buttons),
    hideCrashGames: booleanFormatter(params.hidecrashgames),
    homeUrl: response.params.home_url,
    integrationApi: splitFormatter(params.integration_api),
    isSisalEnabled: booleanFormatter(params.is_sisal),
    isManualPayout: params.ismanualpayout == 'true', // FIXME: not strict check?
    isMicroGamingEnabled: booleanFormatter(params.micro_gaming),
    isResponsibleGamingEnabled: booleanFormatter(params.launch_res_gaming),
    isSessionBalanceEnabled: booleanFormatter(params.italianlobbyenabled),
    languages: splitFormatter(params.languages),
    lobbyVersion: params.lobby_version,
    isLauncherEnabled: booleanFormatter(params.multitablesupport),
    notifyCloseContainer: booleanFormatter(params.notify_close_container),
    returnMainPage: booleanFormatter(params.return_main_page),
    showAlderneyMsg: booleanFormatter(params.show_alderney_msg),
    showBonusBalance: booleanFormatter(params.bonus_balance),
    showNicknameDisclaimer: booleanFormatter(params.show_nickname_disclaimer),
    showDealerInLobby: booleanFormatter(params.show_dealer_name_in_lobby_game_list),
    slotsLobbyEnabled: booleanFormatter(params.slotslobbyenabled),
    tables: tablesFormatter(parseFormatter(params.tables_order)),
    tabs: tabsFormatter(parseFormatter(params.tabs_order)),
    voiceOverTables: splitFormatter(params.voice_over_tables),
    showNlMinBetToast: booleanFormatter(params.show_nl_min_bet_toaster),
    restrictNicknameEdit: booleanFormatter(params.restrict_nickname_edit),
    subtitlesAvailable: params.subtitles_available !== 'false',
  };
};
